import api from './api';
export default {
  getDirectionsList() {
    return api.get('/permissions/directions');
  }
};
